export default "__VITE_ASSET__Ds1VtgE3__"